module.exports = __webpack_public_path__ + "img/icons BFr_40.31375389.svg";